// extracted by mini-css-extract-plugin
export default {"wrapper":"d7C63nL0pPFTM2zMExEE","collapse":"rPIL96CFtGYiwm8qgtvy","title":"hAviitMluR0rEnpusl8E"};